/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BlacklistInputs */

const cs_enum_blacklist = /** @type {(inputs: Enum_BlacklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blacklist`)
};

const en_enum_blacklist = /** @type {(inputs: Enum_BlacklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blacklist`)
};

/**
* | output |
* | --- |
* | "Blacklist" |
*
* @param {Enum_BlacklistInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_blacklist = /** @type {((inputs?: Enum_BlacklistInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BlacklistInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_blacklist(inputs)
	return cs_enum_blacklist(inputs)
});